import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageSquare, Printer, Zap, CalendarDays } from 'lucide-react';

const CommunicationTitleSlide = () => {
  return (
    <div className="h-full w-full flex items-center justify-center p-12 relative overflow-hidden bg-slate-900 text-white">
        {/* Background Elements */}
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-blue-900/20 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-[800px] h-[800px] bg-indigo-900/20 rounded-full blur-[120px] translate-y-1/2 -translate-x-1/2" />

        <div className="relative z-10 flex flex-col items-center text-center max-w-5xl mx-auto space-y-12">
            
            {/* Animated Icons Container */}
            <motion.div 
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="relative"
            >
                {/* Rotating Gradient Border */}
                <div className="absolute -inset-8 rounded-full bg-gradient-to-r from-sky-400 via-blue-500 to-purple-500 opacity-50 blur-xl animate-spin-slow" 
                     style={{ animationDuration: '10s' }} />
                
                {/* Icons Circle */}
                <div className="relative w-48 h-48 md:w-64 md:h-64 rounded-full bg-slate-800 border-4 border-slate-700 shadow-2xl flex items-center justify-center overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-br from-slate-800 to-slate-900" />
                    
                    {/* Floating Icons */}
                    <div className="absolute inset-0 flex items-center justify-center">
                        <motion.div 
                            animate={{ y: [-10, 10, -10] }}
                            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                            className="absolute top-1/4"
                        >
                            <Phone className="w-16 h-16 text-blue-400" />
                        </motion.div>
                        <motion.div 
                            animate={{ x: [-10, 10, -10] }}
                            transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 1 }}
                            className="absolute bottom-1/4 left-1/4"
                        >
                            <MessageSquare className="w-14 h-14 text-purple-400" />
                        </motion.div>
                        <motion.div
                            animate={{ x: [10, -10, 10] }}
                            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                            className="absolute bottom-1/4 right-1/4"
                        >
                            <Printer className="w-14 h-14 text-green-400" />
                        </motion.div>
                        <motion.div
                            animate={{ y: [8, -8, 8] }}
                            transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut", delay: 1.5 }}
                            className="absolute top-1/4 right-1/4"
                        >
                            <CalendarDays className="w-12 h-12 text-blue-400" />
                        </motion.div>
                    </div>
                </div>
            </motion.div>

            {/* Text Content */}
            <div className="space-y-8">
                <motion.h1 
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.3, duration: 0.6 }}
                    className="text-5xl md:text-7xl font-bold tracking-tight"
                >
                    Communication <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">Suite</span>
                </motion.h1>
                
                <motion.div 
                    initial={{ y: 20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.5, duration: 0.6 }}
                    className="space-y-4"
                >
                    <p className="text-xl md:text-3xl text-slate-300 font-light max-w-4xl mx-auto leading-relaxed">
                        VoIP + 2-Way Patient Messaging + EFAX + Online Scheduling
                    </p>
                    <div className="flex items-center justify-center gap-2 text-blue-300 font-medium">
                        <Zap className="w-5 h-5" />
                        <span>All together in one unified platform</span>
                    </div>
                </motion.div>
            </div>

        </div>
    </div>
  );
};

export default CommunicationTitleSlide;























